/* eslint-disable @typescript-eslint/no-unused-vars */

import {
  ActionLogDTO,
  Address,
  AddressInfoDTO,
  AddressVerifyRequest,
  AddressVerifyResponse,
  AiCargoDTO,
  AiResultResponse,
  AllocateDTO,
  AllocateRequest,
  BatchAllocateRequest,
  BizOperRequest,
  BizOperResponse,
  CancelShipmentRequest,
  CarParamConfigDTO,
  CarrierCountDTO,
  CarrierCountResponse,
  CityDTO,
  CommissionAuditRequest,
  CompanyAddRequest,
  CompanyAuditRequest,
  CompanyDetailResponse,
  CompanyEditRequest,
  CompanyPageResponse,
  CompanyQueryRequest,
  CompanyStatusRequest,
  CreditEditRequest,
  CustomerCreditResponse,
  CustomerQuoteConfigDTO,
  CustomerQuoteInfoDTO,
  CustomerQuoteInfoDetailDTO,
  CustomerResponse,
  ExceptionDealDetailResponse,
  ExceptionDealRequest,
  ExceptionDetailResponse,
  ExceptionPageResponse,
  ExceptionQueryRequest,
  FCashOutApproveRequest,
  FCashOutListResponse,
  FCashOutQueryRequest,
  FCashOutResponse,
  FCustomerWalletRequest,
  FCustomerWalletResponse,
  FHistoryBillRequest,
  FRechargeApproveRequest,
  FRechargeListResponse,
  FRechargeQueryRequest,
  FRechargeResponse,
  FTradeRequest,
  FTransactionResponse,
  FWalletResponse,
  FmcsaCarrier,
  FmcsaCarrierListVO,
  FmcsaQueryRequest,
  FmcsaStatusRequest,
  FreightClassRequest,
  HelperInfoReqeust,
  IPage,
  LocalTime,
  LocalTimeReq,
  LocalTimeRes,
  MailQuoteConfigResponse,
  MainQuoteConfigPageResponse,
  MainQuoteConfigQueryRequest,
  MainQuoteConfigRequest,
  OrderAcceptRequest,
  OrderActionLogResponse,
  OrderAddressDTO,
  OrderAddressDTOReq,
  OrderAddressDTORes,
  OrderAmountRecordDTO,
  OrderAmountRequest,
  OrderAmountResponse,
  OrderBatchIdRequest,
  OrderBidPriceRequest,
  OrderCargoDTO,
  OrderCountDTO,
  OrderCountResponse,
  OrderDetailResponse,
  OrderFileRequest,
  OrderListExtResponse,
  OrderPickDateRequest,
  OrderPriceUpdateRequest,
  OrderQueryRequest,
  OrderQuoteDTO,
  OrderQuoteRequest,
  OrderQuoteResultResponse,
  OrderRefNumberUpdateRequest,
  OrderRequest,
  OrderSimpleCargoDTO,
  OrderSimpleInfoDTO,
  OrderTrackingDTO,
  OssFileResponse,
  OwnerQueryRequest,
  OwnerUserAuditRequest,
  OwnerUserEditRequest,
  OwnerUserPwdRequest,
  OwnerUserRequest,
  OwnerUserResponse,
  PageQuery,
  PlaceDetailResponse,
  PlaceResultDTO,
  PlaceResultResponse,
  PlaceSearchRequest,
  PlatformCommodityDTO,
  PlatformOrderCoreRequest,
  PlatformQuoteConfigUpdateRequest,
  PlatformQuoteRateDTO,
  PlatformRateDetailDTO,
  QueryCityPageDTO,
  QueryQuoteAmountDTO,
  QuoteConfigDTO,
  QuoteInfoDTO,
  QuoteInfoDetailDTO,
  QuoteOrderPriceDTO,
  QuoteResultResponse,
  RouteDetailResponse,
  R,
  SalesAmountReportResponse,
  SalesCustomerRequest,
  SalesCustomerResponse,
  SalesDetailResponse,
  SalesOrderCountRequest,
  SalesOrderRequest,
  SalesOrderResponse,
  SalesQueryRequest,
  SalesSimpleResponse,
  SalesUserRequest,
  SalesUserResponse,
  SalesUserStatusVo,
  ServiceQuoteConfigRequest,
  ServiceQuoteConfigResponse,
  ServiceQuoteConfigUpdateRequest,
  ServiceQuoteDetailDTO,
  ShipmentCountResponse,
  ShipmentDetailExtResponse,
  ShipmentPageExtResponse,
  ShipmentQueryRequest,
  ShipmentTrackResponse,
  SysDepartmentTreeVo,
  SysDepartmentVo,
  SysPermission,
  SysPermissionTreeVo,
  SysPermissionVo,
  SysRoleResultVo,
  SysRoleVo,
  SysUserPasswordVo,
  SysUserQueryVo,
  SysUserStatusVo,
  SysUserVo,
  TimeZoneDTO,
  TrackInfo,
  TrackQueryRequest,
  TransferCenterQueryRequest,
  TransferCenterRequest,
  TransferCenterResponse,
  TranslateRequest,
  TranslateResponse,
  UpdateBatchIdDTO,
  UpdateQuoteConfigDisableDTO,
  UserInfoVo,
  UserLoginVo,
  WaybillBolNoUpdateRequest,
  WaybillCountDTO,
  WaybillCountResponse,
  WaybillDetailResponse,
  WaybillFileResponse,
  WaybillPriceRecordDTO,
  WaybillPriceRequest,
  WaybillPriceResponse,
  WaybillPriceUpdateRequest,
  WaybillQueryRequest,
  WaybillRemarkUpdateRequest,
  WaybillRouteInfoDTO,
  WaybillRouteResponse,
  WaybillTrackLogResponse,
  WaybillTruckUpdateRequest,
  WaybillUpdateDriverRequest,
  WaybillUpdateRequest,
} from './type';
import request from '@/utils/request';

export class SalesService {
  // 新增
  public static addSalesUsingPOST(userRequest: SalesUserRequest): Promise<R<string>> {
    return request('POST', '/sales/add', null, null, userRequest, null, null);
  }

  // 佣金审核
  public static auditCommissionUsingPOST(auditRequest: CommissionAuditRequest): Promise<R<string>> {
    return request('POST', '/sales/commission-audit', null, null, auditRequest, null, null);
  }

  // 统计佣金总数
  public static reportCommissionUsingPOST(query: SalesOrderCountRequest): Promise<R<SalesAmountReportResponse>> {
    return request('POST', '/sales/commission-report', null, null, query, null, null);
  }

  // 引入客户记录导出
  public static exportCustomerUsingPOST_1(query: SalesCustomerRequest): Promise<void> {
    return request('POST', '/sales/customer-export', null, null, query, null, null);
  }

  // 查看引入客户记录接口
  public static getCustomerRecordsUsingPOST(query: SalesCustomerRequest): Promise<R<IPage<SalesCustomerResponse>>> {
    return request('POST', '/sales/customer-records', null, null, query, null, null);
  }

  // 兼职销售详情
  public static saleDetailUsingGET(id: number): Promise<R<SalesDetailResponse>> {
    return request('GET', '/sales/detail', null, { id }, null, null, null);
  }

  // 修改
  public static editSalesUsingPOST(userRequest: SalesUserRequest): Promise<R<string>> {
    return request('POST', '/sales/edit', null, null, userRequest, null, null);
  }

  // 分页查询
  public static pageSalesUsingPOST(query: SalesQueryRequest): Promise<R<IPage<SalesUserResponse>>> {
    return request('POST', '/sales/list', null, null, query, null, null);
  }

  // 拥金记录导出
  public static exportSalesOrderUsingPOST(query: SalesOrderRequest): Promise<void> {
    return request('POST', '/sales/order-export', null, null, query, null, null);
  }

  // 返佣订单列表接口
  public static pageSalesOrderRecordsUsingPOST(query: SalesOrderRequest): Promise<R<IPage<SalesOrderResponse>>> {
    return request('POST', '/sales/order-page', null, null, query, null, null);
  }

  // 查看销售拥金记录接口
  public static getSalesOrderRecordsUsingPOST(query: SalesOrderRequest): Promise<R<IPage<SalesOrderResponse>>> {
    return request('POST', '/sales/order-records', null, null, query, null, null);
  }

  // 简单列表查询-查询条件使用
  public static listSalesUsingPOST(query: SalesQueryRequest): Promise<R<IPage<SalesSimpleResponse>>> {
    return request('POST', '/sales/simpleList', null, null, query, null, null);
  }

  // 禁用启用
  public static updateSalesVisibleUsingPUT(statusVo: SalesUserStatusVo): Promise<R<string>> {
    return request('PUT', '/sales/updateStatus', null, null, statusVo, null, null);
  }
}
